import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Market from "@/pages/market/page";
import Trading from "@/pages/trading/page";
import Assets from "@/pages/assets/page";
import Login from "@/pages/login/page";
import Profile from "@/pages/profile/page";
import Kyc from "@/pages/kyc/page";
import Bank from "@/pages/bank/page";
import Notifications from "@/pages/notifications/page";
import Support from "@/pages/support/page";
import CheckRequest from "@/pages/check-request/page";
import Dashboard from "@/pages/dashboard/page";
import Deposit from "@/pages/deposit/page";
import Withdraw from "@/pages/withdraw/page";
import AdminUsers from "@/pages/admin/users/page";
import AdminDeposits from "@/pages/admin/deposits/page";
import AdminOrders from "@/pages/admin/orders/page";
import AdminBanners from "@/pages/admin/banners/page";
import AdminLogs from "@/pages/admin/logs/page";
import AdminSupport from "@/pages/admin/support/page";
import RequireAuth from "@/components/feature/RequireAuth";
import RequireAdmin from "@/components/feature/RequireAdmin";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/thi-truong", element: <RequireAuth><Market /></RequireAuth> },
  { path: "/giao-dich", element: <RequireAuth><Trading /></RequireAuth> },
  { path: "/tai-san", element: <RequireAuth><Assets /></RequireAuth> },
  { path: "/dang-nhap", element: <Login /> },
  { path: "/ho-so", element: <RequireAuth><Profile /></RequireAuth> },
  { path: "/xac-minh-danh-tinh", element: <RequireAuth><Kyc /></RequireAuth> },
  { path: "/ngan-hang", element: <RequireAuth><Bank /></RequireAuth> },
  { path: "/thong-bao", element: <RequireAuth><Notifications /></RequireAuth> },
  { path: "/ho-tro", element: <Support /> },
  { path: "/kiem-tra-yeu-cau", element: <CheckRequest /> },
  { path: "/bang-dieu-khien", element: <RequireAuth><Dashboard /></RequireAuth> },
  { path: "/nap-tien", element: <RequireAuth><Deposit /></RequireAuth> },
  { path: "/rut-tien", element: <RequireAuth><Withdraw /></RequireAuth> },
  { path: "/quan-tri/nguoi-dung", element: <RequireAdmin><AdminUsers /></RequireAdmin> },
  { path: "/quan-tri/nap-rut", element: <RequireAdmin><AdminDeposits /></RequireAdmin> },
  { path: "/quan-tri/lenh-giao-dich", element: <RequireAdmin><AdminOrders /></RequireAdmin> },
  { path: "/quan-tri/banner-tin-tuc", element: <RequireAdmin><AdminBanners /></RequireAdmin> },
  { path: "/quan-tri/nhat-ky", element: <RequireAdmin><AdminLogs /></RequireAdmin> },
  { path: "/quan-tri/ho-tro", element: <RequireAdmin><AdminSupport /></RequireAdmin> },
  { path: "*", element: <NotFound /> },
];

export default routes;